import { Button, Col, Form, Image, Input, InputNumber, Modal, Row, Select, Space, Tabs, Tag, Typography, message, theme } from "antd";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DeleteOutlined, EditOutlined, PrinterOutlined, EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../config/serverApiConfig";
import useTranslation from "../../customHooks/translations";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import Default from "../../styles/1.jpg";
import BeforeAfter, { prefetchBeforeAfter } from "./BeforeAfter";
import Dawakari from "./Dawakari";
import LabResult from "./LabResult";
import PatientCliche from "./PatientCliche";
import NotesPatient from "./NotesPatient";
import Visit from "./Visit";
import Appointment from "./Appointment";
import { hqSrc, thumbSrc } from "../../utils/imageVariant";
import { normalizeRole } from "../../pages/Auth/PermissionType";
import { PATIENT_STATUS, RESERVE_LABEL, isReserveExpired, isReserveStatus, patientStatusColor, patientStatusLabel } from "../../utils/patientStatus";
import ReserveDueModal from "./ReserveDueModal";
import './styles.css';

const { Title, Paragraph } = Typography;

function tabTitle(name, count) {
  return <span>({count || 0}) {name}</span>;
}

export function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function PatientDetail() {
  const { id } = useParams();
  const [formeUpdate] = Form.useForm();
  const translation = useTranslation();
  const [deleteVisible, setDeleteVisible] = React.useState(false);
  const [updateVisible, setUpdateVisible] = React.useState(false);
  const [reserveVisible, setReserveVisible] = React.useState(false);
  const [reserveLoading, setReserveLoading] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [tabCounts, setTabCounts] = React.useState({
    before: 0,
    after: 0,
    needs: 0,
    visits: 0,
    appointments: 0,
    notes: 0,
    labs: 0,
  });
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [visablePassword, setVisablePassword] = React.useState(true);
  const [printVisible, setPrintVisible] = useState(false);
  const componentRef = useRef(null);
  const authSelector = useSelector((state) => state.auth.auth);
  const roleName = normalizeRole(authSelector.role);
  const clinicTabs = roleName === "admin" || roleName === "Secretary";
  const canSendCliche = clinicTabs || roleName === "lab";

  const billable = useSelector((state) => state.clients);
  const { clientSolo } = billable;
  const navigate = useNavigate();

  console.log(clientSolo, "clientSolo");

  const [client, setClient] = useState({
    url: "",
  });
  const { useToken } = theme;
  const { token } = useToken();

  const { TabPane } = Tabs;
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "1");
  const [loadedTabs, setLoadedTabs] = useState({ 1: true, [searchParams.get("tab") || "1"]: true });

  const changeTabCount = useCallback((key, delta) => {
    setTabCounts((prev) => ({
      ...prev,
      [key]: Math.max(0, (prev[key] || 0) + delta),
    }));
    if (key === "visits") {
      setCount((prev) => Math.max(0, prev + delta));
    }
  }, []);

  const openTab = (key) => {
    setActiveTab(key);
    setLoadedTabs((prev) => (prev[key] ? prev : { ...prev, [key]: true }));
  };

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab) openTab(tab);
  }, [searchParams]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}patient/tab-counts/${id}`).then((res) => {
      const next = res.data || {};
      setTabCounts({
        before: next.before || 0,
        after: next.after || 0,
        needs: next.needs || 0,
        visits: next.visits || 0,
        appointments: next.appointments || 0,
        notes: next.notes || 0,
        labs: next.labs || 0,
      });
      setCount(next.visits || 0);
    }).catch(() => {
      axios.get(`${API_BASE_URL}history/count/${id}`).then((res) => {
        setCount(res.data);
        setTabCounts((prev) => ({ ...prev, visits: res.data || 0 }));
      });
    });

    axios.get(`${API_BASE_URL}patient/${id}`).then((res) => {

      console.log(res.data, "res.data😂😥😅🙏🤍✅✅✅✅");
      formeUpdate.setFieldsValue({
        patient: {
          fullName: res.data.fullName,
          age: res.data.age,
          phoneNumber: "0" + res.data.phoneNumber.slice(4),
          status: res.data.status || PATIENT_STATUS.ACTIVE,
          date: res.data.date,
        },
      });

      setClient({
        ...res.data,
      });
    })
    .finally(() => {

   
    // ensure top after the data render
    requestAnimationFrame(() => {
      const el =
        document.querySelector("[data-scroll-container]") ||
        document.querySelector(".ant-layout-content") ||
        document.scrollingElement ||
        document.documentElement;

      el.scrollTo({ top: 0, left: 0, behavior: "auto" });
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    })
  }, [formeUpdate, id]);

  const handleOnBeforeGetContent = React.useCallback(() => {
    return new Promise((resolve) => {
      setPrintVisible(true);

      setTimeout(() => {
        resolve();
      }, 2000);
    });
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => handleOnBeforeGetContent(),
    onAfterPrint: () => setPrintVisible(false),
  });

  const handleOkDelete = () => {
    setDeleteVisible(true);
    setConfirmLoading(true);
    axios.delete(`${API_BASE_URL}patient/${id}`).then((res) => {
      setTimeout(() => {
        setDeleteVisible(false);
        setConfirmLoading(false);
        navigate(-1);
      }, 600);
    });
  };

  const handleOkUpdate = () => {
    setConfirmLoading(true);
  };

  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const handleCancel = () => {
    setDeleteVisible(false);
    setUpdateVisible(false);
  };

  const updateFormInternal = async (e) => {
    const { patient } = e;
    const { image, ...all } = patient;



    axios.put(`${API_BASE_URL}patient/${id}`, {
      ...all,
      phoneNumber: "+964" + all.phoneNumber.slice(1),
      reserveDueDate: all.status === PATIENT_STATUS.RESERVE ? client.reserveDueDate || null : null,
    }).then((res) => {
      setClient({
        ...res.data,
      });
    });

    setConfirmLoading(false);
    setUpdateVisible(false);
  };

  const editMatter = () => {
    setUpdateVisible(true);
    formeUpdate.setFieldsValue({
      contact: {
        ...client,
        age: parseInt(client.age),
      },
    });
  };

  const saveStatus = (nextStatus, reserveDueDate = null) => {
    setReserveLoading(true);
    axios
      .put(`${API_BASE_URL}patient/${id}`, {
        fullName: client.fullName,
        age: client.age,
        phoneNumber: client.phoneNumber,
        image: client.image,
        status: nextStatus,
        reserveDueDate: nextStatus === PATIENT_STATUS.RESERVE ? reserveDueDate : null,
      })
      .then((res) => {
        setClient({ ...res.data });
        formeUpdate.setFieldsValue({
          patient: {
            fullName: res.data.fullName,
            age: res.data.age,
            phoneNumber: res.data.phoneNumber ? "0" + res.data.phoneNumber.slice(4) : "",
            status: res.data.status,
            date: res.data.date,
          },
        });
        setReserveVisible(false);
        message.success(nextStatus === PATIENT_STATUS.RESERVE ? `خرایە ناو لیستی ${RESERVE_LABEL}` : `لە ${RESERVE_LABEL} لادرا`);
      })
      .catch(() => {
        message.error("نەتوانرا بار بگۆڕدرێت");
      })
      .finally(() => {
        setReserveLoading(false);
      });
  };


   useLayoutEffect(() => {
    // prevent browser restoring a previous scroll position
    if ('scrollRestoration' in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
      // optional: restore when unmounting
      return () => { window.history.scrollRestoration = prev; };
    }
  }, []);


useEffect(() => {
    // ensure top after first render
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      // Safari fallback
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, []);


  return (

 <div style={{ overflowX: "clip", margin: "0 5px", padding: "10px 0" }}>

      <Tabs activeKey={activeTab} onChange={openTab}
      className="patient-tabs"
        tabBarGutter={12}

      tabPosition="right" type="card">
        <TabPane tab={"چارەخواز"} key="1">
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", direction: "rtl", width: "100%" }} ref={componentRef}>
            <Row justify={printVisible ? "center" : "space-around"} style={{ width: "100%", position: "relative" }}>
              <Col className="com" style={{ borderRadius: 8, padding: 14, backgroundColor: token.colorBgContainer }} xs={24}>
                <div
                  style={{
                    position: "absolute",
                    left: 0,

                    top: 0,
                  }}
                >
                  <Button onClick={editMatter} type="text">
                    <EditOutlined />
                  </Button>
                  <Button onClick={() => setDeleteVisible(true)} type="text">
                    <DeleteOutlined />
                  </Button>
                  <Button onClick={handlePrint} type="text">
                    <PrinterOutlined />
                  </Button>
                </div>

                <Row justify={"space-between"}>
                  <Col style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }} xs={20}>
                    <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                      <Image
                        width={150}
                        height={150}
                        style={{
                          objectFit: "cover",
                          borderRadius: 80,
                          margin: "0 auto",
                        }}
                        src={client.image ? thumbSrc(client.image) : Default}
                        preview={client.image ? { src: hqSrc(client.image) } : false}
                      />
                      {!printVisible &&
                        (isReserveStatus(client.status) ? (
                          <Button onClick={() => saveStatus(PATIENT_STATUS.ACTIVE)}>لابردن لە {RESERVE_LABEL}</Button>
                        ) : (
                          <Button
                            type="primary"
                            style={{ background: "#9A7200", borderColor: "#9A7200" }}
                            onClick={() => setReserveVisible(true)}
                          >
                            زیادکردن بۆ {RESERVE_LABEL}
                          </Button>
                        ))}
                    </div>
                    <Space className="flex items-start md:items-center w-full mt-[20px] md:flex-row flex-col">
                      <Title style={{ display: "inline" }} level={3}>
                        ناوی تەواو : {client.fullName}
                      </Title>
                      <Title style={{ margin: 0, color: "#29AAF2", display: "inline", opacity: 0.5 }} level={4}>
                        ID-00 {id}
                      </Title>
                    </Space>
                  </Col>
                  {/* <Col>
                    <QRCode color="#14213d" size={100} bordered={false} value={window.location.href} />
                  </Col> */}
                </Row>
              </Col>
            </Row>
            <Form colon={false} layout="horizontal" labelCol={{ span: 3 }}>
              <Row style={{ marginTop: 10 }} justify="center">
                <Col className="com" style={{ borderRadius: 8, padding: 14, backgroundColor: token.colorBgContainer }} xs={24}>
                  <Title level={5} style={{ display: "block", color: "#222" }}>
                    زانیاری چارەخواز
                  </Title>

                  <Row justify="center">
                    <Col xs={24}>
                      <Form.Item
                        style={{ margin: "8px 0" }}
                        label={
                          <p
                            style={{
                              display: "inline",
                              color: "#29AAF2",
                              fontSize: "16px",
                              margin: "auto 0",
                            }}
                          >
                            ژ.م مۆبایل :{" "}
                          </p>
                        }
                      >
                        <div
                          style={{
                            borderBottom: "1px dashed #333",
                            padding: "2px 0",
                            width: "50%",
                          }}
                          className="underGround2"
                        >
                          <a target="_blank" rel="noreferrer" href={`https://wa.me/${client.phoneNumber}/`}>
                            <Paragraph
                              copyable
                              style={{
                                display: "inline",
                                fontSize: "16px",
                                margin: "auto 0",
                                color: "#1c5fed",
                                textDecoration: "underline",
                              }}
                            >
                              0{client.phoneNumber?.slice(4)}
                            </Paragraph>
                          </a>
                        </div>
                      </Form.Item>

                      <Form.Item
                        style={{ margin: "8px 0" }}
                        label={
                          <p
                            style={{
                              display: "inline",
                              color: "#29AAF2",
                              fontSize: "16px",
                              margin: "auto 0",
                            }}
                          >
                            وشەی نهێنی :{" "}
                          </p>
                        }
                      >
                        <div
                          style={{
                            borderBottom: "1px dashed #333",
                            padding: "2px 0",
                            width: "50%",
                          }}
                          className="underGround2"
                        >
                          {/* <div style={{ margin: "10px 0" }}> */}
                          <Paragraph copyable style={{ display: "inline", fontSize: "16px", margin: 0 }}>
                            {!visablePassword ? client.password?.charAt(0) + client.password?.charAt(1) + client.password?.charAt(2) + client.password?.charAt(3) + "*******" : client.password}
                          </Paragraph>
                          <Button onClick={() => setVisablePassword(!visablePassword)} type="link" style={{ display: "inline", fontSize: "16px", margin: 0 }}>
                            {visablePassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                          </Button>
                          {/* </div> */}
                        </div>
                      </Form.Item>

                      <Form.Item
                        style={{ margin: "8px 0" }}
                        label={
                          <p
                            style={{
                              display: "inline",
                              color: "#29AAF2",
                              fontSize: "16px",
                              margin: "auto 0",
                            }}
                          >
                            تەمەن :{" "}
                          </p>
                        }
                      >
                        <div
                          style={{
                            borderBottom: "1px dashed #333",
                            padding: "2px 0",
                            width: "50%",
                          }}
                          className="underGround2"
                        >
                          <Paragraph
                            copyable
                            style={{
                              display: "inline",
                              fontSize: "16px",
                              margin: "auto 0",
                            }}
                          >
                            {" "}
                            {client.age}
                          </Paragraph>
                        </div>
                      </Form.Item>

                      <Form.Item
                        style={{ margin: "8px 0" }}
                        label={
                          <p
                            style={{
                              display: "inline",
                              color: "#29AAF2",
                              fontSize: "16px",
                              margin: "auto 0",
                            }}
                          >
                            بار :{" "}
                          </p>
                        }
                      >
                        <div
                          style={{
                            borderBottom: "1px dashed #333",
                            padding: "2px 0",
                            width: "50%",
                          }}
                          className="underGround2"
                        >
                          <Space wrap>
                            <Tag style={{ fontSize: 17 }} color={patientStatusColor(client.status)}>
                              {patientStatusLabel(client.status)}
                            </Tag>
                            {isReserveStatus(client.status) && client.reserveDueDate && (
                              <Tag color={isReserveExpired(client.reserveDueDate) ? "red" : "gold"}>
                                {isReserveExpired(client.reserveDueDate) ? "بەسەرچوو" : "کۆتایی"} : {dayjs(client.reserveDueDate).format("YYYY/MM/DD")}
                              </Tag>
                            )}
                          </Space>
                        </div>
                      </Form.Item>

                      <Form.Item
                        style={{ margin: "8px 0" }}
                        label={
                          <p
                            style={{
                              display: "inline",
                              color: "#29AAF2",
                              fontSize: "16px",
                              margin: "auto 0",
                            }}
                          >
                            بەرواری دروستکردن :{" "}
                          </p>
                        }
                      >
                        <div
                          style={{
                            borderBottom: "1px dashed #333",
                            padding: "2px 0",
                            width: "50%",
                          }}
                          className="underGround2"
                        >
                          <Paragraph
                            copyable
                            style={{
                              display: "inline",
                              fontSize: "16px",
                              margin: "auto 0",
                            }}
                          >
                            {" "}
                            {client.date}
                          </Paragraph>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>

          <Modal title={translation.Delete + " " + translation.Contact} open={deleteVisible} onOk={handleOkDelete} confirmLoading={confirmLoading} onCancel={handleCancel} centered okText={translation.Delete} cancelText={translation.Cancel}>
            <p>
              {translation.Doyouwantdelete} :{clientSolo.f_name} {clientSolo.l_name}
            </p>
          </Modal>

          <Modal okButtonProps={{ form: "myForm", key: "submit", htmlType: "submit" }} title={translation.Update} open={updateVisible} onOk={handleOkUpdate} centered confirmLoading={confirmLoading} onCancel={handleCancel} okText={translation.Update} cancelText={translation.Cancel}>
            <Form form={formeUpdate} {...layout} name="nest-messages" id="myForm" onFinish={updateFormInternal}>
              <Row justify="center">
                <Form.Item name={["patient", "image"]} style={{ margin: "8px 0" }}>
                  <img
                    alt=""
                    src={client.image ? client.image : Default}
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: 60,
                    }}
                  />
                </Form.Item>
              </Row>

              <Form.Item
                style={{ margin: "8px 0" }}
                name={["patient", "fullName"]}
                label={"ناوی تەواو"}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={"ناوی تەواو"} />
              </Form.Item>

              <Form.Item style={{ margin: "8px 0" }} name={["patient", "phoneNumber"]} label={"ژم.مۆبایل "}>
                <Input placeholder={"ژم.مۆبایل "} />
              </Form.Item>

              <Form.Item style={{ margin: "8px 0" }} name={["patient", "age"]} label={translation.Age}>
                <InputNumber placeholder={translation.Age} />
              </Form.Item>

              <Form.Item style={{ margin: "8px 0" }} name={["patient", "status"]} label={"بار"}>
                <Select>
                  <Select.Option value={PATIENT_STATUS.ACTIVE}>چالاک</Select.Option>
                  <Select.Option value={PATIENT_STATUS.RESERVE}>{RESERVE_LABEL}</Select.Option>
                  <Select.Option value={PATIENT_STATUS.BLOCK}>بلاک لیست</Select.Option>
                </Select>
              </Form.Item>
            </Form>
          </Modal>
          <ReserveDueModal
            open={reserveVisible}
            loading={reserveLoading}
            onCancel={() => setReserveVisible(false)}
            onConfirm={(dueDate) => saveStatus(PATIENT_STATUS.RESERVE, dueDate)}
          />
        </TabPane>

        {clinicTabs && (
          <TabPane
            tab={
              <span
                className="ba-tab-label"
                onMouseEnter={() => prefetchBeforeAfter(id, "before")}
                onFocus={() => prefetchBeforeAfter(id, "before")}
              >
                <span>({tabCounts.before || 0}) پێشتر</span>
                <span>({tabCounts.after || 0}) دواتر</span>
              </span>
            }
            key="6"
          >
            {loadedTabs["6"] ? <BeforeAfter onTabCount={changeTabCount} /> : null}
          </TabPane>
        )}

        {clinicTabs && (
          <TabPane tab={tabTitle("وردەکاری کار", tabCounts.needs)} key="3">
            {loadedTabs["3"] ? <Dawakari /> : null}
          </TabPane>
        )}

        <TabPane tab={tabTitle("سەردانکردنی پێویست", tabCounts.visits || count)} key="8">
          {loadedTabs["8"] ? <Visit onTabCount={changeTabCount} /> : null}
        </TabPane>

        {clinicTabs && (
          <TabPane tab={tabTitle("چاوپێکەوتن", tabCounts.appointments)} key="9">
            {loadedTabs["9"] ? <Appointment onTabCount={changeTabCount} /> : null}
          </TabPane>
        )}

        {clinicTabs && (
          <TabPane tab={tabTitle("تێبینی", tabCounts.notes)} key="5">
            {loadedTabs["5"] ? <NotesPatient onTabCount={changeTabCount} /> : null}
          </TabPane>
        )}

        {canSendCliche && (
          <TabPane tab="پشکنینی شیکاری" key="10">
            {loadedTabs["10"] ? <PatientCliche patientId={id} name={client.fullName} age={client.age} /> : null}
          </TabPane>
        )}

        <TabPane tab={tabTitle("ئەنجامی تاقیگە", tabCounts.labs)} key="4">
          {loadedTabs["4"] ? <LabResult onTabCount={changeTabCount} /> : null}
        </TabPane>
      </Tabs>
 
    </div>
  );
}
//}

export default PatientDetail;
